import { render, staticRenderFns } from "./CompatibilityInformation.vue?vue&type=template&id=fe9d4ae2"
import script from "./CompatibilityInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompatibilityInformation.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports